module.exports = __webpack_public_path__ + "assets/img/custom-paperwallet/icon-fit-to-width.fc075e36a46fc9ebecf375f5ef106638.svg";